import React, { useState, useEffect } from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import useAuth from "../../hooks/useAuth";
import { selectCurrentToken } from "../auth/authSlice";
import { useSelector } from "react-redux";
import Kartice from "./Kartice";
import { useProveraKodaMutation } from "../kodovi/kodoviApiSlice";

const IzborPaketa = () => {
  const { id, email } = useAuth();
  const [promoCode, setPromoCode] = useState("");
  const [message, setMessage] = useState(""); //Za promokod message
  const [error, setError] = useState(""); //Za promokod error
  const [isValid, setIsValid] = useState(true);
  const [aktivan, setAktivan] = useState(null); //Za jedan aktivan
  const [status, setStatus] = useState(null); //Za cancel status
  const [loading, setLoading] = useState(false); //Loading za dugme dektiviraj

  const token = useSelector(selectCurrentToken);

  const [isVisible, setIsVisible] = useState(false);
  const [isCancelationModal, setIsCancelationModal] = useState(false);

  // Zatvara i popup za placanje
  const closePopup = () => {
    setIsVisible(false);
    setIsModalOpen(false);
  };

  const frequencies = [
    { value: "monthly", label: "Mesečno", priceSuffix: "/mesec" },
    { value: "yearly", label: "Godišnje", priceSuffix: "/godina" },
  ];

  const handleSubmitPromocode = (e) => {
    e.preventDefault();
    // Ovde možeš dodati logiku za validaciju promo koda
    if (promoCode === "PROMO2025") {
      setIsValid(true);
      alert("Promo kod je uspešno primenjen!");
    } else {
      setIsValid(false);
    }
  };

  const [
    proveriKod,
    {
      isSuccess: isSuccessProveriKod,
      isError: isErrorProveriKod,
      isLoading: isLoadingProveriKod,
      error: errorProveriKod,
      data: dataProveriKod,
    },
  ] = useProveraKodaMutation();

  const tiers = [
    // {
    //   id: 1,
    //   name: "Besplatni",
    //   mostPopular: false,
    //   description: {
    //     monthly: "Početne funkcionalnosti iz aplikacije.",
    //     yearly: "Početne funkcionalnosti iz aplikacije.",
    //   },
    //   price: {
    //     monthly: "0RSD",
    //     yearly: "0RSD",
    //   },
    //   features: {
    //     monthly: [
    //       "Sve računice BMI, BMR, TDEE...",
    //       "Procene Vaših parametara",
    //       "Kompletni izveštaji za 3 i 7 dana",
    //       "1 jelovnik",
    //     ],
    //     yearly: [
    //       "Sve računice BMI, BMR, TDEE...",
    //       "Procene Vaših parametara",
    //       "Kompletni izveštaji za 3 i 7 dana",
    //       "1 jelovnik",
    //     ],
    //   },
    // },
    {
      id: 2,
      name: "Osnovni",
      mostPopular: true,
      description: {
        monthly:
          "Osnovne funkcionalnosti iz aplikacije za narednih mesec dana.",
        yearly:
          "Osnovne funkcionalnosti iz aplikacije za narednih godinu dana.",
      },
      price: {
        monthly: "3000RSD", //"3000RSD"
        yearly: "25000RSD", //"25000RSD"
      },
      features: {
        monthly: [
          "Sve računice BMI, BMR, TDEE...",
          "Procene Vaših parametara",
          "Kompletni izveštaji za 3 i 7 dana",
          "8 jelovnika mesečno",
        ],
        yearly: [
          "Sve računice BMI, BMR, TDEE...",
          "Procene Vaših parametara",
          "Kompletni izveštaji za 3 i 7 dana",
          "8 jelovnika mesečno",
          "Konsultacije sa nutricionistom (30 min mesečno)",
          "Garancija povrata novca",
        ],
      },
    },
    {
      id: 3,
      name: "Napredni",
      mostPopular: false,
      description: {
        monthly: "Napredne funkcionalnosti iz aplikacije za mesec dana.",
        yearly:
          "Napredne funkcionalnosti iz aplikacije za narednih godinu dana.",
      },
      price: {
        monthly: "12000RSD",
        yearly: "90000RSD",
      },
      features: {
        monthly: [
          "Sve računice BMI, BMR, TDEE...",
          "Procene Vaših parametara",
          "Kompletni izveštaji za 3 i 7 dana",
          "20 jelovnika mesečno",
          "Konsultacije sa nutricionistom (30 min mesečno)",
          "Garancija povrata novca",
          "Planovi mršavljenja (umereno i agresivno)",
        ],
        yearly: [
          "Sve računice BMI, BMR, TDEE...",
          "Procene Vaših parametara",
          "Kompletni izveštaji za 3 i 7 dana",
          "20 jelovnika mesečno",
          "Konsultacije sa nutricionistom (30 min mesečno)",
          "Garancija povrata novca",
          "Planovi mršavljenja (umereno i agresivno)",
        ],
      },
    },
    // {
    //   id: 4,
    //   name: "Premium",
    //   mostPopular: false,
    //   description: {
    //     monthly: "Napredne funkcionalnosti za mesec dana.",
    //     yearly: "Napredne funkcionalnosti za godinu dana.",
    //   },
    //   price: {
    //     monthly: "2RSD",
    //     yearly: "20RSD",
    //   },
    //   features: {
    //     monthly: ["Napredne funkcionalnosti", "Prioritetna podrška"],
    //     yearly: ["Napredne funkcionalnosti", "Prioritetna podrška"],
    //   },
    // },
    // {
    //   id: 5,
    //   name: "Premium",
    //   mostPopular: false,
    //   description: {
    //     monthly: "Napredne funkcionalnosti za mesec dana.",
    //     yearly: "Napredne funkcionalnosti za godinu dana.",
    //   },
    //   price: {
    //     monthly: "2RSD",
    //     yearly: "20RSD",
    //   },
    //   features: {
    //     monthly: ["Napredne funkcionalnosti", "Prioritetna podrška"],
    //     yearly: ["Napredne funkcionalnosti", "Prioritetna podrška"],
    //   },
    // },
  ];

  const [frequency, setFrequency] = useState(frequencies[0]);
  const [selectedTier, setSelectedTier] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPaymentModal, setIsPaymentModal] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);

  // Proverava paket
  const getPakete = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/get-pakete/${id}`
      );
      const result = await response.json();
      setAktivan(result.data);
    } catch (error) {
      console.error("Greška prilikom učitavanja paketa:", error);
    }
  };

  //Da fetchuje paket za popup kad hoce da canceluje - ODKOMENTARISI!!!
  useEffect(() => {
    getPakete();
  }, []);

  //Proveri kod proveriKod work here
  useEffect(() => {
    if (isSuccessProveriKod) {
      // alert(proveriKod.message.toString());
      setMessage(dataProveriKod.message.toString());
      setError("");
    }

    if (isErrorProveriKod) {
      // alert(errorProveriKod?.data?.message);
      setError(errorProveriKod?.data?.message);
      setMessage("");
    }
  }, [isSuccessProveriKod, isErrorProveriKod, errorProveriKod, dataProveriKod]);

  //Otvara modal za placanje
  const handleOpenModal = (tier) => {
    if (aktivan != null) {
      setIsVisible(true);
    }
    setSelectedTier(tier);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsPaymentModal(false);
    setAcceptTerms(false);
  };

  //Provera koda
  // const handleUpdateKod = async () => {
  //   const headers = new Headers();

  //   try {
  //     const response = await fetch(`${process.env.REACT_APP_API_URL}/kod/provera`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`, // Dodajte token ovde
  //       },
  //       body: JSON.stringify({
  //         naziv: promoCode,
  //         idUser: id,
  //       }),
  //     });

  //     const data = await response.json();

  //     if (response.ok) {
  //       setMessage(data.message);
  //       setError("");
  //       console.log(data.message);
  //     } else {
  //       setError(data.message);
  //       setMessage("");
  //       console.log(data.message);
  //     }
  //   } catch (err) {
  //     // setError("Došlo je do greške prilikom slanja zahteva.");
  //     console.error(err);
  //   }
  // };

  let removePaket = () => {
    setStatus(null);
    setIsCancelationModal(false);
  };

  const handleOpenPaymentModal = async () => {
    if (!acceptTerms) {
      alert("Morate prihvatiti uslove korišćenja!");
      return;
    }

    if (promoCode != "") {
      // await handleUpdateKod();
      // console.log("Imaaa");
      await proveriKod({ naziv: promoCode, klijentId: id });
      setIsModalOpen(false);
      setIsPaymentModal(true);
    } else {
      //POSALJI PROVERU PROMO KODA...
      // console.log("koddd");
      // console.log("Nemaaa");
      setIsModalOpen(false);
      setIsPaymentModal(true);
    }
  };

  const handleBuyPlan = async (tier) => {
    // const amount = tier.price[frequency.value].replace("RSD", "").trim();
    const amount = parseFloat(
      tier.price[frequency.value].replace("RSD", "").trim()
    ).toFixed(2);
    const orderId = `${tier.name}-${Date.now()}`; //Premium-238746296382 - Ovo cu da cuvam kao naziv
    // const okUrl = `${process.env.REACT_APP_API_URL}/bankaSuccess`;
    // const failUrl = `${process.env.REACT_APP_API_URL}/bankaFail`;
    const okUrl = `${process.env.REACT_APP_API_URL}/bankaSuccess`;
    const failUrl = `${process.env.REACT_APP_API_URL}/bankaFail`; //LOKAL CLIENT GADJA REMOTE SERVER ZBOG BANKE

    const paketId = tier.id; //Za id paketa na klijentu
    const duration = frequency.value;

    // console.log("Prosledjen mail =>", email);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/generate-payment-form`,
        // "https://nutritrans.rs:5000/generate-payment-form",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id,
            email,
            orderId,
            amount,
            okUrl,
            failUrl,
            paketId,
            duration,
          }),
        }
      );

      const { payURL, formData, recurringMessage } = await response.json();

      console.log("Primljen odgovor sa servera:", recurringMessage); // OVO PROVERI U BROWSER KONZOLI

      if (!recurringMessage) {
        console.error("❌ Backend nije poslao recurringMessage!");
      }

      const form = document.createElement("form");
      form.method = "POST";
      form.action = payURL;

      //Osnovna polja
      Object.entries(formData).forEach(([key, value]) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = value;
        form.appendChild(input);
      });

      // Dodavanje polja za ponavljajuće plaćanje
      if (duration === "monthly") {
        const recurringFields = {
          RecurringPaymentNumber: "99",
          RecurringFrequencyUnit: "m", // Frekventna jedinica (d je za dane, m za mesečno, w za nedeljno)
          RecurringFrequency: "1", // Frekvencija (1 znači jednom mesečno)
        };

        const periodUnit =
          recurringFields.RecurringFrequencyUnit === "m"
            ? "mesec"
            : recurringFields.RecurringFrequencyUnit === "d"
            ? "dan"
            : "nedelja";

        const recurringText = `Ukupno ${
          recurringFields.RecurringPaymentNumber
        } iznosa će biti naplaćeno svakih ${
          recurringFields.RecurringFrequency
        } ${periodUnit}${
          recurringFields.RecurringFrequency !== "1" ? "i" : ""
        }`;

        console.log("✅ Pravilno formatiran tekst:", recurringText);

        const recurringInput = document.createElement("input");
        recurringInput.type = "hidden";
        recurringInput.name = "recurringMessage";
        recurringInput.value = recurringText;
        form.appendChild(recurringInput);

        Object.entries(recurringFields).forEach(([key, value]) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = key;
          input.value = value;
          form.appendChild(input);
        });
      }

      document.body.appendChild(form);
      form.submit();
    } catch (error) {
      console.error("Error generating payment form:", error);
    }
  };

  //Cancel paket
  const sendXmlRequest = async (setStatus) => {
    setLoading(true);
    const url = `${process.env.REACT_APP_API_URL}/proxy`;

    //Name => Merchent name, pass => clientid => merchent id
    //Promeni pass !!!!!!
    //Produkcija = ZZ7S6bJ3LAcEKgt
    //Dev = 6Vhju7kj47Q8pjV

    const xmlData = `<?xml version="1.0" encoding="UTF-8"?>
    <CC5Request>
        <Name>DMVadmin</Name>
        <Password>${process.env.REACT_APP_API_CANCEL}</Password>
        <ClientId>13IN003415</ClientId>
        <Extra>
            <RECURRINGOPERATION>Cancel</RECURRINGOPERATION>
            <RECORDTYPE>Recurring</RECORDTYPE>
            <RECORDID>${aktivan?.recurringID}</RECORDID>
        </Extra>
    </CC5Request>`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: xmlData,
          user: { id, tranId: aktivan.TransId, email, aktivan },
        }),
      });

      if (!response.ok) {
        // throw new Error(`HTTP error! status: ${response.status}`);
        alert(
          `${response.status} Greska pri otkazivanju paketa, kontaktirajte korisnicku sluzbu office@nutritrans.com`
        );
      }

      const responseText = await response.text();

      setStatus({ success: true, message: "Request successful!" });
      setAktivan(null);
      setIsVisible(false);
    } catch (error) {
      console.error("Error sending XML request:", error);
      setStatus({
        success: false,
        message: "Request failed: " + error.message,
      });
    }
  };

  return (
    <>
      {/* mx-auto max-w-7xl px-6 lg:px-8 mt-10 => Je bilo kada je imalo 3 komada */}
      <div className="mx-auto max-w-4xl px-6 lg:px-8 mt-10">
        {/* <div className="mx-auto max-w-4xl text-center">
          <p className="mt-2 text-5xl font-semibold tracking-tight text-gray-900 sm:text-6xl">
            Kupite paket
          </p>
        </div> */}
        {/* <p className="mx-auto mt-6 max-w-2xl text-center text-lg font-medium text-gray-600 sm:text-xl/8">
          Izaberite paket koji najbolje odgovara vašim potrebama i ciljevima,
          kako bismo zajedno ostvarili optimalno zdravlje uz personalizovane
          nutricionističke planove. Nudimo dva načina plaćanja: jednokratno
          plaćanje za 12 meseci korišćenja aplikacije ili putem mesečne
          pretplate, koja će se automatski obnavljati.
        </p> */}

        <div className="mt-8 flex justify-center">
          <fieldset aria-label="Učestalost plaćanja">
            <div className="grid grid-cols-2 gap-x-1 rounded-full p-1 text-center text-xs/5 font-semibold ring-1 ring-inset ring-gray-200">
              {frequencies.map((option) => (
                <button
                  key={option.value}
                  onClick={() => setFrequency(option)}
                  className={`cursor-pointer rounded-full px-2.5 py-1 ${
                    frequency.value === option.value
                      ? "bg-green-600 text-white"
                      : "text-gray-500"
                  }`}
                >
                  {option.label}
                </button>
              ))}
            </div>
          </fieldset>
        </div>
        {/* lg:grid-cols-3 => Kada je bilo 3 komada */}
        <div className="isolate mx-auto mt-10 grid max-w-md grid-cols-1 gap-8 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          {tiers.map((tier) => (
            <div
              key={tier.id}
              className={`rounded-3xl p-8 xl:p-10 ${
                tier.mostPopular
                  ? "ring-2 ring-green-600"
                  : "ring-1 ring-gray-200"
              }`}
            >
              <div className="flex items-center justify-between gap-x-4">
                <h3
                  className={`text-lg font-semibold ${
                    tier.mostPopular ? "text-green-600" : "text-gray-900"
                  }`}
                >
                  {tier.name}
                </h3>
                {tier.mostPopular && (
                  <p className="rounded-full bg-green-600/10 px-2.5 py-1 text-xs font-semibold text-green-600">
                    Najpopularniji
                  </p>
                )}
              </div>
              <p className="mt-4 text-sm text-gray-600">
                {tier.description[frequency.value]}
              </p>
              <p className="mt-6 flex items-baseline gap-x-1">
                <span className="text-4xl font-semibold text-gray-900">
                  {parseInt(
                    tier.price[frequency.value].replace(/[^\d.-]/g, ""),
                    10
                  ).toLocaleString("en-US")}{" "}
                  RSD
                </span>

                <span className="text-sm font-semibold text-gray-600">
                  {frequency.priceSuffix}
                </span>
              </p>
              <button
                disabled={tier.name == "Besplatni"}
                onClick={() => handleOpenModal(tier)}
                className={`mt-6 block w-full rounded-md px-3 py-2 text-center text-sm font-semibold text-white shadow-sm 
                  ${
                    tier.name === "Besplatni"
                      ? "bg-red-600 cursor-not-allowed"
                      : "bg-green-600 hover:bg-green-500"
                  }`}
              >
                Izaberi paket
              </button>
              <ul
                role="list"
                className="mt-8 space-y-3 text-sm text-gray-600 xl:mt-10"
              >
                {tier.features[frequency.value].map((feature) => (
                  <li key={feature} className="flex gap-x-3">
                    <span className="text-green-600">✔</span> {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        {/* <div className="isolate mx-auto mt-10 grid max-w-none grid-cols-1 gap-8 lg:mx-0 lg:max-w-none lg:grid-cols-5">
          {tiers.map((tier) => (
            <div
              key={tier.id}
              className={`rounded-3xl p-4 xl:p-6 ${
                // Reduced padding here
                tier.mostPopular
                  ? "ring-2 ring-green-600"
                  : "ring-1 ring-gray-200"
              }`}
            >
              <div className="flex items-center justify-between gap-x-4">
                <h3
                  className={`text-lg font-semibold ${
                    tier.mostPopular ? "text-green-600" : "text-gray-900"
                  }`}
                >
                  {tier.name}
                </h3>
                {tier.mostPopular && (
                  <p className="rounded-full bg-green-600/10 px-2.5 py-1 text-xs font-semibold text-green-600">
                    Najpopularniji
                  </p>
                )}
              </div>
              <p className="mt-4 text-sm text-gray-600">
                {tier.description[frequency.value]}
              </p>
              <p className="mt-6 flex items-baseline gap-x-1">
                <span className="text-4xl font-semibold text-gray-900">
                  {tier.price[frequency.value]}
                </span>
                <span className="text-sm font-semibold text-gray-600">
                  {frequency.priceSuffix}
                </span>
              </p>
              <button
                onClick={() => handleOpenModal(tier)}
                className="mt-6 block w-full rounded-md bg-green-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-green-500"
              >
                Kupi paket
              </button>
              <ul
                role="list"
                className="mt-8 space-y-3 text-sm text-gray-600 xl:mt-10"
              >
                {tier.features[frequency.value].map((feature) => (
                  <li key={feature} className="flex gap-x-3">
                    <span className="text-green-600">✔</span> {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div> */}

        <br />
        <br />
        <Kartice />
        {/* <br />
        <br />
        <br />
        <br /> */}
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-md shadow-md w-96">
            <div className="flex justify-between items-center mb-3">
              <h2 className="text-lg font-semibold">Vaš odabran plan</h2>
              <button onClick={handleCloseModal}>
                <span className="text-gray-500">✖</span>
              </button>
            </div>

            <table className="min-w-full table-auto border-collapse border border-gray-300">
              <tbody>
                <tr className="border-b">
                  <td className="px-4 py-2 text-sm text-gray-800">
                    Naziv paketa
                  </td>
                  <td className="px-4 py-2 text-sm text-gray-800">
                    {selectedTier.name}
                  </td>
                </tr>
                <tr className="border-b">
                  <td className="px-4 py-2 text-sm text-gray-800">
                    Frekvencija paketa
                  </td>
                  <td className="px-4 py-2 text-sm text-gray-800">
                    {frequency.label}
                  </td>
                </tr>
                <tr>
                  <td className="px-4 py-2 text-sm text-gray-800">
                    Cena paketa
                  </td>
                  <td className="px-4 py-2 text-sm text-gray-800">
                    {/* {selectedTier.price[frequency.value]} */}
                    {parseInt(
                      selectedTier.price[frequency.value].replace(
                        /[^\d.-]/g,
                        ""
                      ),
                      10
                    ).toLocaleString("en-US")}{" "}
                    RSD
                  </td>
                </tr>
              </tbody>
            </table>

            <h2 className="text-lg font-semibold mb-0 mt-3">
              Upišite Vaš promo kod
            </h2>

            <div className="relative">
              <input
                id="promoCode"
                type="text"
                value={promoCode}
                onChange={(e) => setPromoCode(e.target.value)}
                className={`w-full p-4 pl-10 pr-4 text-lg border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-300 ease-in-out ${
                  isValid ? "border-gray-300" : "border-red-500"
                }`}
                placeholder="Unesite kod"
              />
              <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                🔑
              </span>
            </div>

            <div className="bg-yellow-100 text-yellow-800 p-2 text-center mt-4">
              {frequency.label == "Mesečno"
                ? "Ovaj paket se automatski obnavlja svakog meseca na datum prve uplate. Pretplatu možete otkazati u bilo kom trenutku, bez dodatnih obaveza."
                : "Ovaj godišnji paket plaća se jednim iznosom i važi godinu dana od datuma uplate."}
            </div>

            {/* Test */}
            {/* <div className="bg-yellow-500 p-2 text-center text-white mt-4">
              Ovaj godišnji paket plaća se jednim iznosom i važi tokom cele
              godine.
            </div> */}

            {/* Ostali podaci */}
            <div className="mt-4">
              <ul className="list-disc pl-5 text-sm text-gray-800">
                {selectedTier.features[frequency.value].map(
                  (feature, index) => (
                    <li key={index}>{feature}</li>
                  )
                )}
              </ul>
            </div>

            <div className="mt-4">
              <label className="flex items-center text-sm">
                <input
                  type="checkbox"
                  checked={acceptTerms}
                  onChange={() => setAcceptTerms(!acceptTerms)}
                  className="mr-2"
                />
                Prihvatam&nbsp;
                <a
                  href="https://nutritrans.rs/terms"
                  className="text-red-500 hover:text-blue-500 hover:underline"
                  target="_blank"
                  rel="noreferrer"
                >
                  uslove korišćenja
                </a>
              </label>
            </div>
            <button
              disabled={!acceptTerms}
              onClick={handleOpenPaymentModal}
              className={`mt-4 w-full rounded-md px-4 py-2 ${
                acceptTerms
                  ? "bg-green-600 text-white"
                  : "bg-gray-400 text-gray-800"
              }`}
            >
              Potvrdi
            </button>
          </div>
        </div>
      )}

      {isPaymentModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-md shadow-md w-96">
            <div className="flex justify-between items-center mb-3">
              <h2 className="text-lg font-semibold"></h2>
              <button onClick={handleCloseModal}>
                <span className="text-gray-500">✖</span>
              </button>
            </div>

            {/* STATUS KODA work here */}
            {/* {isLoadingProveriKod && (
              
            )} */}

            {isLoadingProveriKod ? (
              <span>Proverava se kod</span>
            ) : (
              <>
                {" "}
                {error && (
                  <div className="bg-red-100 text-red-800 p-4 rounded-md mb-4 flex flex-col items-center">
                    <p className="text-sm text-center">{error}</p>
                  </div>
                )}
                {message && (
                  <div className="bg-green-100 text-green-800 p-4 rounded-md mb-4 flex flex-col items-center">
                    <p className="text-sm text-center">{message}</p>
                  </div>
                )}{" "}
              </>
            )}

            <div className="bg-yellow-100 text-yellow-800 p-4 rounded-md mb-4 flex flex-col items-center">
              <p className="text-sm text-center">
                Bezbednost vaših podataka u procesu kupovine garantuje procesor
                platnih kartica, Banca Intesa a.d. Beograd, a ceo proces se
                završava na internet stranicama banke. Podacima o Vašoj platnoj
                kartici se ni u jednom trenutku ne može pristupiti iz našeg
                sistema, a NutriTrans neće biti odgovoran za bilo kakvu
                zloupotrebu istih.
              </p>
            </div>

            <table className="min-w-full table-auto border-collapse border border-gray-300">
              <tbody>
                <tr className="border-b">
                  <td className="px-4 py-2 text-sm text-gray-800">
                    Naziv paketa
                  </td>
                  <td className="px-4 py-2 text-sm text-gray-800">
                    {selectedTier.name}
                  </td>
                </tr>
                <tr className="border-b">
                  <td className="px-4 py-2 text-sm text-gray-800">
                    Tip paketa
                  </td>
                  <td className="px-4 py-2 text-sm text-gray-800">
                    {frequency.label}
                  </td>
                </tr>
                <tr>
                  <td className="px-4 py-2 text-sm text-gray-800">
                    Cena paketa
                  </td>
                  <td className="px-4 py-2 text-sm text-gray-800">
                    {parseInt(
                      selectedTier.price[frequency.value].replace(
                        /[^\d.-]/g,
                        ""
                      ),
                      10
                    ).toLocaleString("en-US")}{" "}
                    RSD
                  </td>
                </tr>
              </tbody>
            </table>

            <button
              onClick={() => handleBuyPlan(selectedTier)}
              className="mt-4 w-full rounded-md px-4 py-2 bg-green-600 text-white"
            >
              Plati
            </button>
          </div>
        </div>
      )}

      {isVisible && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
            <h2 className="text-xl font-semibold text-center text-green-600">
              Aktivni paket!
            </h2>
            <p className="text-center text-gray-700 mt-2">
              Trenutno imate aktivan paket. Ako želite da kupite nov paket,
              potrebno je prvo da deaktivirate stari.
            </p>
            <button
              onClick={() => sendXmlRequest(setStatus)}
              disabled={loading}
              className="mt-4 w-full bg-red-500 text-white py-2 rounded-lg hover:bg-red-600"
            >
              {loading ? "Deaktivacija u toku..." : "Deaktiviraj"}
            </button>
            <button
              onClick={closePopup}
              className="mt-4 w-full bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600"
            >
              Zatvori
            </button>
          </div>
        </div>
      )}

      {/* RESPONSE DISPLAY ZA STATUS CANCELOVANJA RECCURING OPCIJE */}
      {status && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
          <div className="bg-white rounded-lg shadow-xl w-96 p-6 relative">
            <button
              onClick={() => removePaket()}
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
            >
              &#x2715;
            </button>
            <div className="text-center">
              <h2
                className={
                  status.success
                    ? "text-green-600 text-xl font-semibold"
                    : "text-red-600 text-xl font-semibold"
                }
              >
                {status.success
                  ? "Usepšno ste otkazali pretplatu!"
                  : "Otkazivanje nije uspelo!"}
              </h2>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default IzborPaketa;
